import Vue from 'vue'
import 'element-ui/lib/theme-chalk/index.css'
Vue.prototype.$ELEMENT = { size: 'small', zIndex: 2000 }

import { Checkbox, Select, Option, Button, Input, Loading, DatePicker, Result } from 'element-ui'
[
    Input,
    Checkbox,
    Select,
    Option,
    Button,
    Loading,
    DatePicker,
    Result
].forEach(item => {
    Vue.use(item)
})
